import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { stateOptionsSample } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { UserService } from '../../../../services/user.service';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fund-return-retrival-modal',
  templateUrl: './fund-return-retrival-modal.component.html',
  styleUrls: ['./fund-return-retrival-modal.component.scss']
})
export class FundReturnRetrivalModalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  fundRetrivalRequestForm: UntypedFormGroup;
  optionsSelect = stateOptionsSample;
  typeList: any;
  returnList: any;
  ApplicationID: any;
  userType: any;
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    private commonService: CommonService,
  ) {
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-007');

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    this.typeList = [
      { "value": "Fund", "label": "Fund", checked: true }
    ]

    this.returnList = [
      { "value": "Cheque", "label": "Cheque" },
      { "value": "BankAccount", "label": "Bank account" },
    ]

    this.returnList = [{ label: "Select", value: null, checked: true }].concat(this.returnList);

    this.userType = this.userService.getUserType();
    this.fundRetrivalRequestForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      Application_ID: new UntypedFormControl(null),
      RETRIVE_RETURN_QUANTITY: new UntypedFormControl(this.Content.content.ReturnAmount),
      RETRIVE_NOTES: new UntypedFormControl(null),
      TYPE: new UntypedFormControl("Fund"),
      RETURN_VIA: new UntypedFormControl(null),
    });

    this.fundRetrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].disable();
  }

  SaveFundRerive() {
    if (this.ValidateControls()) {
      var formData = this.fundRetrivalRequestForm.value;
      formData["RETRIVE_RETURN_QUANTITY"] = parseFloat(this.fundRetrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].value);
      formData["ProductID"] = this.Content.content.id;
      this.summaryService.Insert("api/ISTAllRequests/UpdateFundRetrivalStatus", formData).subscribe(result => {
        this.commonService.SuccessBanner("Retrieval Request raised successfully");
        this.modalRef.close();
      });
    }
  }

  ValidateControls(): boolean {
    let isValid: boolean = true;
    let message = "";
    let RETRIVE_RETURN_QUANTITY = $("#RETRIVE_RETURN_QUANTITY").val();
    let RETRIVE_NOTES = $("#RETRIVE_NOTES").val();
    let TYPE = this.fundRetrivalRequestForm.controls["TYPE"].value;
    let RETURN_VIA = this.fundRetrivalRequestForm.controls["RETURN_VIA"].value;

    //Retrieve Type
    if (this.staticformFields?.RETRIEVE_TYPE.IS_Display) {
      if ((TYPE == null || TYPE == "" || TYPE == undefined)
        && this.staticformFields?.RETRIEVE_TYPE.IS_MANDATORY) {
        $("#TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.RETRIEVE_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#TYPE").addClass("ng-untouched ng-valid");
        $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //Retrieve Amount
    if (this.staticformFields?.RETURN_AMOUNT.IS_Display) {
      if ((RETRIVE_RETURN_QUANTITY == null || RETRIVE_RETURN_QUANTITY == "" || RETRIVE_RETURN_QUANTITY == undefined)
        && this.staticformFields?.RETURN_AMOUNT.IS_MANDATORY) {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.RETURN_AMOUNT.LABEL_NAME}<br/>`;
        isValid = false;
      }
      else {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-untouched ng-valid");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    //Return Via
    if (this.staticformFields?.RETURN_VIA.IS_Display) {
      if ((RETURN_VIA == null || RETURN_VIA == "" || RETURN_VIA == undefined)
        && this.staticformFields?.RETURN_VIA.IS_MANDATORY) {
        $("#RETURN_VIA").addClass("ng-touched ng-invalid validate-error");
        $("#RETURN_VIA").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.RETURN_VIA.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#RETURN_VIA").addClass("ng-untouched ng-valid");
        $("#RETURN_VIA").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.RETURN_AMOUNT.IS_Display && this.staticformFields?.ALLOCATED_FUND.IS_Display) {
      if (RETRIVE_RETURN_QUANTITY !== null && RETRIVE_RETURN_QUANTITY !== "" && RETRIVE_RETURN_QUANTITY !== undefined) {
        RETRIVE_RETURN_QUANTITY = RETRIVE_RETURN_QUANTITY + "";
        let returned = parseFloat(RETRIVE_RETURN_QUANTITY);
        let allocated = parseFloat(this.Content.content.Allocated);

        if (returned > allocated) {
          $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
          $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields?.RETURN_AMOUNT.LABEL_NAME} should be less than ${this.staticformFields?.ALLOCATED_FUND.LABEL_NAME}<br/>`;
          isValid = false;
        }
      }
    }

    //Notes
    if (this.staticformFields?.RETRIVE_FUND_NOTES.IS_Display && this.staticformFields?.RETRIVE_FUND_NOTES.IS_MANDATORY) {
      if ((RETRIVE_NOTES == null || RETRIVE_NOTES == "" || RETRIVE_NOTES == undefined))
      {
        $("#RETRIVE_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.RETRIVE_FUND_NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      } else if(RETRIVE_NOTES!= null && RETRIVE_NOTES != undefined && RETRIVE_NOTES.trim()==""){
        $("#RETRIVE_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.RETRIVE_FUND_NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      }
      else {
        $("#RETRIVE_NOTES").addClass("ng-untouched ng-valid");
        $("#RETRIVE_NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }
}
